/* eslint-disable no-unused-vars */
//store/modules/auth.js

import axios from 'axios';
const state = {
    user: '',
    webid: '',
    available: '',
    isAdmin: false,
    token: localStorage.getItem('token') || '',
    isActive: false,
    expiry: ''
};

const mutations = {
    setUser(state, webid){
        state.user = webid
    },

    setAvailable(state, status) {
        state.available = status
    },

    logout(state){
        state.user    = null
        state.isAdmin = ''
        state.isActive = false
        state.expiry   = ''
    },

    auth_success(state, user) {
        state.user     = user.username
        state.webid    = user.webid
        state.isAdmin  = !!Number(user.admin)
        state.isActive = Boolean(user.active)
        state.expiry   = user.tarikh_tamat
    },

    auth_error(state) {
        state.user     = ''
        state.webid    = ''
        state.isAdmin  = ''
        state.isActive = false
        state.expiry   = ''
    } 
};

const getters = {
    isLoggedIn:     state => !!state.user,  
    isAdmin:        state => state.isAdmin,    
    stateUser:      state => state.user,
    stateWebID:     state => state.webid,
    stateAvailable: state => state.available,
    isActive:       state => state.isActive,  
    expiry:         state => state.expiry 
};

const actions = {
    async Register({dispatch}, form) {
        return new Promise((resolve, reject) => {            
            axios.post('register', form)
            .then(resp => {
                resolve(resp)
            })
            .catch( err => {    
                reject(err.response.data)
            })
        })
  
    },
    
    async Update({state, dispatch}, form) {
        form.webid = state.webid

        return new Promise((resolve, reject) => {            
            axios.put('update', form)
            .then(resp => {
                resolve(resp)
            })
            .catch( err => {    
                reject(err.response.data)
            })
        })
  
    },
    
    async Login({commit}, User) {
        return new Promise((resolve, reject) => {
            axios.post('login', User)
            .then( resp => {
                const { webid, username, admin, token, active, tarikh_tamat } = resp.data
                commit('auth_success', {webid, username, admin, active, tarikh_tamat})
                localStorage.setItem('token', token)
                axios.defaults.headers.common['Authorization'] = token
                resolve(resp)
            })
            .catch( err => {
                commit('auth_error')
                localStorage.removeItem('token')
                reject(err)
            })
            
        })
    },  
    
    async LogOut({commit}){
        commit('logout')
        axios('logout')
    },

    async idcheck({commit}, webid) {
        if(webid.length > 0) {
            await axios('idcheck/' + webid)
            .then(({data}) => {
                commit('setAvailable', data.status);
            })
        }
    }      
};

export default {
  state,
  getters,
  actions,
  mutations
};
